import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import {DataSharing} from '../helpers/core/data.sharing';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            const myRawToken = DataSharing.getToken();
            const pageToken = DataSharing.getPageToken();
            const helper = new JwtHelperService();
            const isExpired = helper.isTokenExpired(myRawToken);
            if (pageToken) {
                return true;
            }
            if (!isExpired) {
                return true;
            } else {
                this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
                return false;
            }
        } catch (e) {
            this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
            return false;
        }
    }
}
